<div class="modal-header border-bottom p-3">
  <h5 id="offcanvasAddUserLabel" class="offcanvas-title">
    {{ "BarcodeScan" | translate }}
    &nbsp;&nbsp;&nbsp;&nbsp;
    {{ drugName }}
  </h5>
  <button
    type="button"
    class="btn-close-modal btn-icon btn-close"
    (click)="callParent('closeUid', undefined)"
    aria-label="Close"
  ></button>
</div>
<div class="modal-body mx-0 flex-grow-0">
  <div class="fourth-box row border-card mx-1 py-2">
    <div class="col-12">
      <p>{{ "UIDScanDescription" | translate }}</p>
    </div>
    <ng-container *ngFor="let item of barcodeList; let i = index">
      <div class="barcode-box mt-2 col-12">
        <div class="input-group input-daterange">
          <span class="input-group-text">
            {{ i + 1 }}
          </span>
          <input
            type="text"
            [disabled]="!item.active"
            id="barcode"
            class="form-control go-to-next"
            autocomplete="off"
            [(ngModel)]="item.uId"
            [attr.placeholder]="'barcode' | translate"
          />
          <input
            type="text"
            id="count"
            [disabled]="!item.active"
            class="form-control go-to-next"
            autocomplete="off"
            [(ngModel)]="item.count"
            [attr.placeholder]="'count' | translate"
          />
          <button
            *ngIf="item.active"
            type="button"
            class="input-group-text add"
            (click)="saveBarcode(item)"
          >
            <i class="fa fa-save search-desable"></i>
          </button>
          <button
            *ngIf="!item.active"
            type="button"
            class="input-group-text delete"
            (click)="removeBarcode(item)"
          >
            <i class="fa fa-trash search-desable"></i>
          </button>
        </div>
      </div>
    </ng-container>

  </div>
  <div class="col-12 mt-2 d-flex justify-content-center align-items-center">
    <button type="button" class="btn btn-primary" (click)="saveOnPrescription()">
      <i class="fas fa-save"></i>
      {{ 'AddToPrescription' | translate }}
    </button>
  </div>
</div>
<app-loading-panel *ngIf="loading"></app-loading-panel>
<!-- <div class="modal-footer border-top p-3 justify-content-center">
  <button type="submit" class="btn btn-secondary me-sm-3 me-1 data-submit">
    {{ "close" | translate }}
  </button>
</div> -->
